module.exports = __webpack_public_path__ + "static/img/stay.08129ad6.png";